import { iRequest } from '@/utils/requestutil';

export async function saveDailyKnotConfig(payload) {
  return iRequest(`/iwms-openapi/api/dailyKnotConfig`, {
    method: 'POST',
    body: payload,
  });
}

export async function offline(payload) {
  return iRequest(
    `/iwms-openapi/api/dailyKnotConfig/offline?configUuid=${payload.configUuid}`,
    {
      method: 'POST',
      // body: payload,
    },
  );
}

export async function online(payload) {
  return iRequest(
    `/iwms-openapi/api/dailyKnotConfig/online?configUuid=${payload.configUuid}`,
    {
      method: 'POST',
      // body: payload,
    },
  );
}

export async function queryconfig(payload) {
  return iRequest(
    `/iwms-openapi/api/dailyKnotConfig/queryconfig?companyUuid=${payload.companyUuid}`,
  );
}

export async function querylog(payload) {
  return iRequest(`/iwms-openapi/api/dailyKnotConfig/querylog`, {
    method: 'POST',
    body: payload,
  });
}
